import { render } from "./VrModal.vue?vue&type=template&id=f666da84&scoped=true"
import script from "./VrModal.vue?vue&type=script&lang=js"
export * from "./VrModal.vue?vue&type=script&lang=js"

import "./VrModal.vue?vue&type=style&index=0&id=f666da84&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f666da84"]])

export default __exports__